import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_e3a85c30 from 'nuxt_plugin_plugin_e3a85c30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_hotmartRumserver_a05a7d6c from 'nuxt_plugin_hotmartRumserver_a05a7d6c' // Source: ./hotmartRum.server.js (mode: 'server')
import nuxt_plugin_hotmartRumclient_4a194fc2 from 'nuxt_plugin_hotmartRumclient_4a194fc2' // Source: ./hotmartRum.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_14c106b4 from 'nuxt_plugin_cookieuniversalnuxt_14c106b4' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_cookieplugin6bb699e0_92afb304 from 'nuxt_plugin_cookieplugin6bb699e0_92afb304' // Source: ./cookie.plugin.6bb699e0.js (mode: 'all')
import nuxt_plugin_pluginutils_70479e06 from 'nuxt_plugin_pluginutils_70479e06' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_10d719f0 from 'nuxt_plugin_pluginrouting_10d719f0' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_4f589567 from 'nuxt_plugin_pluginmain_4f589567' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_948af158 from 'nuxt_plugin_gtm_948af158' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_db68ce04 from 'nuxt_plugin_axios_db68ce04' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_lazysizes_29833f8d from 'nuxt_plugin_lazysizes_29833f8d' // Source: ../plugins/lazysizes.js (mode: 'all')
import nuxt_plugin_fontawesome_c99c6992 from 'nuxt_plugin_fontawesome_c99c6992' // Source: ../plugins/fontawesome.js (mode: 'all')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"layout","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"distribution","content":"global"},{"name":"author","content":"Hotmart"}],"link":[{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Fstatic\u002Fapp-hotmart-legal\u002Fimages\u002Ficons\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Fstatic\u002Fapp-hotmart-legal\u002Fimages\u002Ficons\u002Ffavicon-16x16.png"},{"rel":"shortcut icon","href":"\u002Fstatic\u002Fapp-hotmart-legal\u002Fimages\u002Ficons\u002Ffavicon.ico"},{"rel":"mask-icon","href":"\u002Fstatic\u002Fapp-hotmart-legal\u002Fimages\u002Ficons\u002Fsafari-pinned-tab.svg","color":"#f04e23"},{"href":"https:\u002F\u002Ffonts.gstatic.com\" crossorigin","rel":"preconnect"},{"href":"https:\u002F\u002Fwww.googletagmanager.com\u002F","rel":"dns-prefetch"},{"href":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=GTM-TT4GHQX","rel":"preconnect"},{"href":"https:\u002F\u002Fstatic.hotmart.com\u002Ffonts\u002Fv1\u002Fcss\u002Fhotmart-sans.min.css","rel":"stylesheet"}],"script":[{"hid":"hotmart-tracking-manager","src":"https:\u002F\u002Fhotmart-tracking-manager.hotmart.com\u002Fhotmart-tracking-manager.min.js","defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TT4GHQX&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_e3a85c30 === 'function') {
    await nuxt_plugin_plugin_e3a85c30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_hotmartRumserver_a05a7d6c === 'function') {
    await nuxt_plugin_hotmartRumserver_a05a7d6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotmartRumclient_4a194fc2 === 'function') {
    await nuxt_plugin_hotmartRumclient_4a194fc2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_14c106b4 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_14c106b4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieplugin6bb699e0_92afb304 === 'function') {
    await nuxt_plugin_cookieplugin6bb699e0_92afb304(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_70479e06 === 'function') {
    await nuxt_plugin_pluginutils_70479e06(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_10d719f0 === 'function') {
    await nuxt_plugin_pluginrouting_10d719f0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_4f589567 === 'function') {
    await nuxt_plugin_pluginmain_4f589567(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_948af158 === 'function') {
    await nuxt_plugin_gtm_948af158(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_db68ce04 === 'function') {
    await nuxt_plugin_axios_db68ce04(app.context, inject)
  }

  if (typeof nuxt_plugin_lazysizes_29833f8d === 'function') {
    await nuxt_plugin_lazysizes_29833f8d(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_c99c6992 === 'function') {
    await nuxt_plugin_fontawesome_c99c6992(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
